exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.edit-booking[data-v-be758f7e]{display:grid;grid-gap:100px\n}\n@media (min-width:700px){\n.edit-booking[data-v-be758f7e]{grid-template-columns:1fr 1fr;position:relative\n}\n.edit-booking[data-v-be758f7e]:before{border-left:1px solid #d5dde2;content:\"\";height:100%;left:50%;position:absolute;top:0\n}\n}", ""]);

// exports
